<template>
  <div>
    <div
      v-if="theme !== 'employment'"
      class="box"
    >
      <form>
        <div class="field">
          <label class="label">To: <span class="tag is-info is-medium">{{ theme }}</span></label>
        </div>
        <div class="field">
          <label class="label">Subject</label>
          <div class="control">
            <input
              v-model="subject"
              class="input"
              :class="{'is-danger': validation.subject}"
              type="text"
              placeholder="Subject"
            >
          </div>
          <p
            v-if="validation.subject"
            class="help is-danger"
          >
            The subject is required
          </p>
        </div>
        <div class="field">
          <label class="label">Your Name</label>
          <div class="control">
            <input
              v-model="name"
              class="input"
              :class="{'is-danger': validation.name}"
              type="text"
              placeholder="Your Name"
            >
          </div>
          <p
            v-if="validation.name"
            class="help is-danger"
          >
            The name is required
          </p>
        </div>
        <hr>
        <div class="field">
          <label class="label">Your E-mail Address</label>
          <div class="control">
            <input
              v-model="email"
              class="input"
              :class="{'is-danger': validation.email}"
              type="email"
              placeholder="example@gmail.com"
            >
          </div>
          <p
            v-if="validation.email"
            class="help is-danger"
          >
            The email is required
          </p>
          <p
            v-if="validation.notEmail"
            class="help is-danger"
          >
            This field must be email
          </p>
        </div>
        <div class="field">
          <label class="label">Repeat E-mail Address</label>
          <div class="control">
            <input
              v-model="emailConfirm"
              class="input"
              :class="{'is-danger': validation.confirm}"
              type="email"
              placeholder="example@gmail.com"
            >
          </div>
          <p
            v-if="validation.confirm"
            class="help is-danger"
          >
            The email is not confirmed
          </p>
        </div>
        <p>
          Your e-mail address needs to be correct.
          It allows us to contact you easily to respond.
        </p>
        <hr>
        <div class="field is-horizontal">
          <div class="field-label">
            <label class="label">Your AHL Number,
              or AHL Poker Nickname</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input
                  v-model="ahlid"
                  class="input"
                  :class="{'is-danger': validation.ahlid}"
                  type="text"
                >
              </div>
            </div>
          </div>
        </div>
        <p
          v-if="validation.ahlid"
          class="help is-danger"
        >
          The AHL Number must contains only numbers in format XXXXXXXX
        </p>
        <hr>
        <div class="field">
          <label class="label">Message</label>
          <div class="control">
            <textarea
              v-model="message"
              class="textarea"
              :class="{'is-danger': validation.message}"
              placeholder="Message"
            />
          </div>
          <p
            v-if="validation.message"
            class="help is-danger"
          >
            The message is required
          </p>
        </div>
        <div class="field is-grouped">
          <div class="control">
            <button
              class="button is-info"
              @click.prevent="submitForm()"
            >
              Submit
            </button>
          </div>
          <div class="control">
            <button
              class="button is-link"
              @click="back()"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
    <!--Employment form-->
    <div
      v-if="theme === 'employment'"
      class="box"
    >
      <form class="is-small">
        <div v-if="employmentPage === 1">
          <div class="field">
            <label class="label">To: <span class="tag is-info is-medium">{{ theme }}</span></label>
          </div>
          <div class="field">
            <label class="label">Your Name</label>
            <div class="control">
              <input
                v-model="name"
                class="input"
                :class="{'is-danger': validation.name}"
                type="text"
                placeholder="Your name"
              >
            </div>
            <p
              v-if="validation.name"
              class="help is-danger"
            >
              The name is required
            </p>
          </div>
          <div class="field">
            <label class="label">Position Desired</label>
            <div class="control">
              <div class="select select-position">
                <select v-model="position">
                  <option>Sales Representative</option>
                  <option>Tournament Director</option>
                </select>
              </div>
            </div>
            <p
              v-if="validation.position"
              class="help is-danger"
            >
              Choose the position
            </p>
          </div>
          <hr>
          <div class="field">
            <label class="label">Your E-mail Address</label>
            <div class="control">
              <input
                v-model="email"
                class="input"
                :class="{'is-danger': validation.email, 'is-danger': validation.notEmail}"
                type="email"
                placeholder="example@gmail.com"
              >
            </div>
            <p
              v-if="validation.email"
              class="help is-danger"
            >
              The email is required
            </p>
            <p
              v-if="validation.notEmail"
              class="help is-danger"
            >
              This field must be email
            </p>
          </div>
          <div class="field">
            <label class="label">Repeat E-mail Address</label>
            <div class="control">
              <input
                v-model="emailConfirm"
                class="input"
                :class="{'is-danger': validation.confirm}"
                type="email"
                placeholder="example@gmail.com"
              >
            </div>
            <p
              v-if="validation.confirm"
              class="help is-danger"
            >
              The email is not confirmed
            </p>
          </div>
          <div class="field">
            <label class="label">Phone</label>
            <div class="control">
              <input
                v-model="phone"
                class="input"
                :class="{'is-danger': validation.phone}"
                type="tel"
                placeholder="555 555 555"
              >
            </div>
            <p
              v-if="validation.phone"
              class="help is-danger"
            >
              The phone is required
            </p>
          </div>
          <div class="field">
            <label class="label">Address</label>
            <div class="control">
              <input
                v-model="address"
                class="input"
                :class="{'is-danger': validation.address}"
                type="text"
                placeholder="Street 2/3"
              >
            </div>
            <p
              v-if="validation.address"
              class="help is-danger"
            >
              The address is required
            </p>
          </div>
          <div class="field">
            <label class="label">City</label>
            <div class="control">
              <input
                v-model="city"
                class="input"
                :class="{'is-danger': validation.city}"
                type="text"
                placeholder="City"
              >
            </div>
            <p
              v-if="validation.city"
              class="help is-danger"
            >
              The city is required
            </p>
          </div>
          <div class="field">
            <label class="label">State</label>
            <div class="control">
              <input
                v-model="state"
                class="input"
                :class="{'is-danger': validation.state}"
                type="text"
                placeholder="State"
              >
            </div>
            <p
              v-if="validation.state"
              class="help is-danger"
            >
              The state is required
            </p>
          </div>
          <p>All contact information above is required and must be valid for consideration.</p>
          <p class="field">
            <a
              class="button is-small"
              @click="previousEmploymentPage()"
            >
              <span class="icon">
                <i class="far fa-chevron-left" />
              </span>
              <span>Back</span>
            </a>
            <a
              class="button is-small"
              @click="nextEmploymentPage(1)"
            >
              <span>Next</span>
              <span class="icon">
                <i class="far fa-chevron-right" />
              </span>
            </a>
          </p>
        </div>
        <div v-if="employmentPage === 2">
          <div class="field">
            <label class="label has-text-centered">Employment history</label>
          </div>
          <div class="field">
            <label class="label has-text-left">Last Employer</label>
          </div>
          <div class="field">
            <label class="label">Name</label>
            <div class="control">
              <input
                v-model="lastEmployerName"
                class="input"
                :class="{'is-danger': validation.lastEmployerName}"
                type="text"
                placeholder="Name"
              >
            </div>
            <p
              v-if="validation.lastEmployerName"
              class="help is-danger"
            >
              This field is required
            </p>
          </div>
          <div class="field">
            <label class="label">Phone</label>
            <div class="control">
              <input
                v-model="lastEmployerPhone"
                class="input"
                :class="{'is-danger': validation.lastEmployerPhone}"
                type="tel"
                placeholder="Phone"
              >
            </div>
            <p
              v-if="validation.lastEmployerPhone"
              class="help is-danger"
            >
              This field is required
            </p>
          </div>
          <div class="field">
            <label class="label">Dates Worked</label>
            <div class="control is-flex">
              <input
                v-model="lastEmployerDatesWorkedFrom"
                :class="{'is-danger': validation.lastEmployerDatesWorkedFrom}"
                class="input dates-worked"
                type="text"
                placeholder="from"
              >
              <input
                v-model="lastEmployerDatesWorkedTo"
                :class="{'is-danger': validation.lastEmployerDatesWorkedTo}"
                class="input"
                type="text"
                placeholder="to"
              >
            </div>
            <p
              v-if="validation.lastEmployerDatesWorkedFrom || validation.lastEmployerDatesWorkedTo"
              class="help is-danger"
            >
              These fields are required
            </p>
          </div>
          <div class="field">
            <label class="label">Reason for leaving</label>
            <div class="control">
              <input
                v-model="lastEmployerReason"
                class="input"
                :class="{'is-danger': validation.lastEmployerReason}"
                type="text"
                placeholder="Reason for leaving"
              >
            </div>
            <p
              v-if="validation.lastEmployerReason"
              class="help is-danger"
            >
              This field is required
            </p>
          </div>
          <div class="field">
            <label class="label has-text-left label-border">Previous Employer (optional)</label>
          </div>
          <div class="field">
            <label class="label">Name</label>
            <div class="control">
              <input
                v-model="previousEmployerOneName"
                class="input"
                type="text"
                placeholder="Name"
              >
            </div>
          </div>
          <div class="field">
            <label class="label">Phone</label>
            <div class="control">
              <input
                v-model="previousEmployerOnePhone"
                class="input"
                type="tel"
                placeholder="Phone"
              >
            </div>
          </div>
          <div class="field">
            <label class="label">Dates Worked</label>
            <div class="control is-flex">
              <input
                v-model="previousEmployerOneDatesWorkedFrom"
                class="input dates-worked"
                type="text"
                placeholder="from"
              >
              <input
                v-model="previousEmployerOneDatesWorkedTo"
                class="input"
                type="text"
                placeholder="to"
              >
            </div>
          </div>
          <div class="field">
            <label class="label">Reason for leaving</label>
            <div class="control">
              <input
                v-model="previousEmployerOneReason"
                class="input"
                type="text"
                placeholder="Reason for leaving"
              >
            </div>
          </div>
          <div class="field">
            <label class="label has-text-left label-border">Previous Employer (optional)</label>
          </div>
          <div class="field">
            <label class="label">Name</label>
            <div class="control">
              <input
                v-model="previousEmployerTwoName"
                class="input"
                type="text"
                placeholder="Name"
              >
            </div>
          </div>
          <div class="field">
            <label class="label">Phone</label>
            <div class="control">
              <input
                v-model="previousEmployerTwoPhone"
                class="input"
                type="tel"
                placeholder="Phone"
              >
            </div>
          </div>
          <div class="field">
            <label class="label">Dates Worked</label>
            <div class="control is-flex">
              <input
                v-model="previousEmployerTwoDatesWorkedFrom"
                class="input dates-worked"
                type="text"
                placeholder="from"
              >
              <input
                v-model="previousEmployerTwoDatesWorkedTo"
                class="input"
                type="text"
                placeholder="to"
              >
            </div>
          </div>
          <div class="field">
            <label class="label">Reason for leaving</label>
            <div class="control">
              <input
                v-model="previousEmployerTwoReason"
                class="input"
                type="text"
                placeholder="Reason for leaving"
              >
            </div>
          </div>
          <p class="field">
            <a
              class="button is-small"
              @click="previousEmploymentPage()"
            >
              <span class="icon">
                <i class="far fa-chevron-left" />
              </span>
              <span>Back</span>
            </a>
            <a
              class="button is-small"
              @click="nextEmploymentPage(2)"
            >
              <span>Next</span>
              <span class="icon">
                <i class="far fa-chevron-right" />
              </span>
            </a>
          </p>
        </div>
        <div v-if="employmentPage === 3">
          <div class="field">
            <label class="label has-text-centered">Personal References</label>
          </div>
          <div class="field">
            <label class="label has-text-left">Reference 1</label>
          </div>
          <div class="field">
            <label class="label">Name</label>
            <div class="control">
              <input
                v-model="referenceOneName"
                class="input"
                :class="{'is-danger': validation.referenceName}"
                type="text"
                placeholder="Name"
              >
            </div>
            <p
              v-if="validation.referenceName"
              class="help is-danger"
            >
              This field is required
            </p>
          </div>
          <div class="field">
            <label class="label">Phone</label>
            <div class="control">
              <input
                v-model="referenceOnePhone"
                class="input"
                :class="{'is-danger': validation.referencePhone}"
                type="tel"
                placeholder="Phone"
              >
            </div>
            <p
              v-if="validation.referencePhone"
              class="help is-danger"
            >
              This field is required
            </p>
          </div>
          <div class="field">
            <label class="label">Years Known</label>
            <div class="control">
              <input
                v-model="referenceOneYears"
                class="input"
                :class="{'is-danger': validation.referenceYears}"
                type="text"
                placeholder="Years Known"
              >
            </div>
            <p
              v-if="validation.referenceYears"
              class="help is-danger"
            >
              This field is required
            </p>
          </div>
          <div class="field">
            <label class="label has-text-left">Reference 2</label>
          </div>

          <div class="field">
            <label class="label">Name</label>
            <div class="control">
              <input
                v-model="referenceTwoName"
                class="input"
                type="text"
                placeholder="Name"
              >
            </div>
          </div>

          <div class="field">
            <label class="label">Phone</label>
            <div class="control">
              <input
                v-model="referenceTwoPhone"
                class="input"
                type="tel"
                placeholder="Phone"
              >
            </div>
          </div>

          <div class="field">
            <label class="label">Years Known</label>
            <div class="control">
              <input
                v-model="referenceTwoYears"
                class="input"
                type="text"
                placeholder="Years Known"
              >
            </div>
          </div>

          <div class="field">
            <label class="label has-text-left">Reference 3</label>
          </div>

          <div class="field">
            <label class="label">Name</label>
            <div class="control">
              <input
                v-model="referenceThreeName"
                class="input"
                type="text"
                placeholder="Name"
              >
            </div>
          </div>

          <div class="field">
            <label class="label">Phone</label>
            <div class="control">
              <input
                v-model="referenceThreePhone"
                class="input"
                type="tel"
                placeholder="Phone"
              >
            </div>
          </div>

          <div class="field">
            <label class="label">Years Known</label>
            <div class="control">
              <input
                v-model="referenceThreeYears"
                class="input"
                type="text"
                placeholder="Years Known"
              >
            </div>
          </div>
          <p class="field">
            <a
              class="button is-small"
              @click="previousEmploymentPage()"
            >
              <span class="icon">
                <i class="far fa-chevron-left" />
              </span>
              <span>Back</span>
            </a>
            <a
              class="button is-small"
              @click="nextEmploymentPage(3)"
            >
              <span>Next</span>
              <span class="icon">
                <i class="far fa-chevron-right" />
              </span>
            </a>
          </p>
        </div>
        <div v-if="employmentPage === 4">
          <div class="field">
            <label class="label has-text-centered">Additional Information</label>
          </div>
          <p>Please provide any additional information that may help us consider you for this position</p>
          <div class="field">
            <label class="label">Message</label>
            <div class="control">
              <textarea
                v-model="addInfo"
                class="textarea"
                placeholder="Message"
              />
            </div>
          </div>

          <div class="field is-grouped">
            <div class="control">
              <button
                class="button is-info"
                @click.prevent="sendEmploymentForm()"
              >
                Submit
              </button>
            </div>
            <div class="control">
              <button
                class="button is-link"
                @click="back()"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'ContactForm',
    metaInfo: {
      title: 'AHL Poker :: Contact'
    },
    props: ['user', 'token'],
    data () {
      return {
        theme: '',
        employmentPage: 1,
        subject: '',
        name: '',
        email: '',
        emailConfirm: '',
        ahlid: '',
        message: '',
//        Employment Form
        position: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        lastEmployerName: '',
        lastEmployerPhone: '',
        lastEmployerDatesWorkedFrom: '',
        lastEmployerDatesWorkedTo: '',
        lastEmployerReason: '',
        previousEmployerOneName: '',
        previousEmployerOnePhone: '',
        previousEmployerOneDatesWorkedFrom: '',
        previousEmployerOneDatesWorkedTo: '',
        previousEmployerOneReason: '',
        previousEmployerTwoName: '',
        previousEmployerTwoPhone: '',
        previousEmployerTwoDatesWorkedFrom: '',
        previousEmployerTwoDatesWorkedTo: '',
        previousEmployerTwoReason: '',
        referenceOneName: '',
        referenceOnePhone: '',
        referenceOneYears: '',
        referenceTwoName: '',
        referenceTwoPhone: '',
        referenceTwoYears: '',
        referenceThreeName: '',
        referenceThreePhone: '',
        referenceThreeYears: '',
        addInfo: '',
        validation: {
          name: false,
          email: false,
          notEmail: false,
          subject: false,
          ahlid: false,
          message: false,
          position: false,
          confirm: false,
          phone: false,
          address: false,
          city: false,
          state: false,
          lastEmployerName: false,
          lastEmployerPhone: false,
          lastEmployerDatesWorkedFrom: false,
          lastEmployerDatesWorkedTo: false,
          lastEmployerReason: false,
          referenceName: false,
          referencePhone: false,
          referenceYears: false
        }
      }
    },
    mounted () {
      if (this.$route.params.theme) {
        this.theme = this.$route.params.theme
      } else this.$router.push('/')
      this.employmentPage = 1
      if (this.user) {
        this.ahlid = this.user.ahlid
      }
    },
    methods: {
      validateForm () {
        let valid = true
        let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        let ahlidRegex = /^\d+$/
        this.ahlid = this.appendZeros(this.ahlid)
        this.validation.name = false
        this.validation.email = false
        this.validation.notEmail = false
        this.validation.subject = false
        this.validation.ahlid = false
        this.validation.confirm = false
        this.validation.message = false
        if (this.name.length === 0) {
          this.validation.name = true
          valid = false
        }
        if (this.subject.length === 0) {
          this.validation.subject = true
          valid = false
        }
        if (this.ahlid.length !== 8 || !ahlidRegex.test(this.ahlid)) {
          this.validation.ahlid = true
          valid = false
        }
        if (this.email.length === 0) {
          this.validation.email = true
          valid = false
        }
        if (!emailRegex.test(this.email)) {
          this.validation.notEmail = true
          valid = false
        }
        if (this.emailConfirm.length === 0 || this.emailConfirm !== this.email) {
          this.validation.confirm = true
          valid = false
        }
        if (this.message.length === 0) {
          this.validation.message = true
          valid = false
        }
        if (!valid) return false
        return true
      },
      validateFirstPage () {
        let valid = true
        let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        this.validation.name = false
        this.validation.email = false
        this.validation.notEmail = false
        this.validation.position = false
        this.validation.confirm = false
        this.validation.phone = false
        this.validation.address = false
        this.validation.city = false
        this.validation.state = false
        if (this.name.length === 0) {
          this.validation.name = true
          valid = false
        }
        if (this.email.length === 0) {
          this.validation.email = true
          valid = false
        }
        if (!emailRegex.test(this.email)) {
          this.validation.notEmail = true
          valid = false
        }
        if (this.position.length === 0) {
          this.validation.position = true
          valid = false
        }
        if (this.emailConfirm.length === 0 || this.emailConfirm !== this.email) {
          this.validation.confirm = true
          valid = false
        }
        if (this.phone.length === 0) {
          this.validation.phone = true
          valid = false
        }
        if (this.address.length === 0) {
          this.validation.address = true
          valid = false
        }
        if (this.city.length === 0) {
          this.validation.city = true
          valid = false
        }
        if (this.state.length === 0) {
          this.validation.state = true
          valid = false
        }
        if (!valid) return false
        return true
      },
      validateSecondPage () {
        let valid = true
        this.validation.lastEmployerName = false
        this.validation.lastEmployerPhone = false
        this.validation.lastEmployerDatesWorkedFrom = false
        this.validation.lastEmployerDatesWorkedTo = false
        this.validation.lastEmployerReason = false
        if (this.lastEmployerName.length === 0) {
          this.validation.lastEmployerName = true
          valid = false
        }
        if (this.lastEmployerPhone.length === 0) {
          this.validation.lastEmployerPhone = true
          valid = false
        }
        if (this.lastEmployerDatesWorkedFrom.length === 0) {
          this.validation.lastEmployerDatesWorkedFrom = true
          valid = false
        }
        if (this.lastEmployerDatesWorkedTo.length === 0 || this.emailConfirm !== this.email) {
          this.validation.lastEmployerDatesWorkedTo = true
          valid = false
        }
        if (this.lastEmployerReason.length === 0) {
          this.validation.lastEmployerReason = true
          valid = false
        }
        if (!valid) return false
        return true
      },
      validateThirdPage () {
        let valid = true
        this.validation.referenceName = false
        this.validation.referencePhone = false
        this.validation.referenceYears = false
        if (this.referenceOneName.length === 0) {
          this.validation.referenceName = true
          valid = false
        }
        if (this.referenceOnePhone.length === 0) {
          this.validation.referencePhone = true
          valid = false
        }
        if (this.referenceOneYears.length === 0 || this.emailConfirm !== this.email) {
          this.validation.referenceYears = true
          valid = false
        }
        if (!valid) return false
        return true
      },
      submitForm () {
        if (!this.validateForm()) return false
        this.$axios({
          method: 'POST',
          url: `general/contactreq/new`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || '',
            to: this.theme,
            subject: this.subject,
            name: this.name,
            position: this.position,
            email: this.email,
            ahlid: this.ahlid,
            body: this.message
          }
        })
          .then((res) => {
            this.$emit('message',
              {
                showDialog: true,
                error: false,
                message: res.data.message
              })
            this.$router.push('/')
          })
          .catch((err) => {
            this.$emit('message',
              {
                showDialog: true,
                error: true,
                message: err.response.data.message
              })
          })
      },
      sendEmploymentForm () {
        this.$axios({
          method: 'POST',
          url: `general/employment`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            name: this.name,
            position: this.position,
            email: this.email,
            phone: this.phone,
            address: this.address,
            city: this.city,
            state: this.state,
            lemp_name: this.lastEmployerName,
            lemp_phone: this.lastEmployerPhone,
            lemp_date1: this.lastEmployerDatesWorkedFrom,
            lemp_date2: this.lastEmployerDatesWorkedTo,
            lemp_rfl: this.lastEmployerReason,
            r1_name: this.referenceOneName,
            r1_phone: this.referenceOnePhone,
            r1_yrsknown: this.referenceOneYears,
            // Optional
            addlinfo: this.addInfo,
            p1emp_name: this.previousEmployerOneName,
            p1emp_phone: this.previousEmployerOnePhone,
            p1emp_date1: this.previousEmployerOneDatesWorkedFrom,
            p1emp_date2: this.previousEmployerOneDatesWorkedTo,
            p1emp_rfl: this.previousEmployerOneReason,
            r2_name: this.referenceTwoName,
            r2_phone: this.referenceTwoPhone,
            r2_yrsknown: this.referenceTwoYears,
            p2emp_name: this.previousEmployerTwoName,
            p2emp_phone: this.previousEmployerTwoPhone,
            p2emp_date1: this.previousEmployerTwoDatesWorkedFrom,
            p2emp_date2: this.previousEmployerTwoDatesWorkedTo,
            p2emp_rfl: this.previousEmployerTwoReason,
            r3_name: this.referenceThreeName,
            r3_phone: this.referenceThreePhone,
            r3_yrsknown: this.referenceThreeYears
          }
        })
          .then((res) => {
            this.$emit('message',
              {
                showDialog: true,
                error: false,
                message: 'Thank you for applying with AHL Poker, someone will contact you soon!'
              })
            this.$router.push('/')
          })
      },
      nextEmploymentPage (pageNumber) {
        if (pageNumber === 1) {
          if (!this.validateFirstPage()) return false
        } else if (pageNumber === 2) {
          if (!this.validateSecondPage()) return false
        } else if (pageNumber === 3) {
          if (!this.validateThirdPage()) return false
        }
        if (this.employmentPage < 4) {
          this.employmentPage++
        }
      },
      previousEmploymentPage () {
        if (this.employmentPage > 1) {
          this.employmentPage--
        }
      },
      back () {
        this.$router.push('/contact')
      },
      appendZeros (number) {
        let string = number.toString()
        while (string.length < 8) {
          string = '0' + string
        }
        return string
      }
    }
  }
</script>
